export const AUTH_ENDPOINTS = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  LOGOUT: "/auth/logout",
  REFRESH: "/auth/refresh",
  ME: "/users/me",
  REQUEST_FORGOT_PASSWORD: "/emails/forgot-password",
  SEND_2FA_CODE: "/emails/send-2FA-code",
  VERIFY_2FA_OTP: "/auth/confirm-2FA-otp",
  CONFIRM_OTP: "/auth/confirm-otp",
  CONFIRM_RESET_TOKEN: "/auth/confirm-reset-token",
  UPDATE_PASSWORD: "/auth/update-password",
};
